// extracted by mini-css-extract-plugin
export var badgeTextContainer = "_1j-2";
export var blackBorderOnHover = "_1j-7";
export var cell = "_1j-6";
export var cellContainer = "_1j-3";
export var checked = "_1j-8";
export var disabled = "_1j-5";
export var featuredIconCellContainer = "_1j-9";
export var featuredIconTextContainer = "_1j-b";
export var featuredIconWrapper = "_1j-a";
export var noBorder = "_1j-c";
export var orangeSelectedRow = "_4g-3";
export var overflowableText = "_1j-0";
export var overflowableTextContainer = "_1j-1";
export var row = "_1k-0";
export var rowCheckboxCell = "_1j-4";
export var selectableTable = "_4g-2";